import {type TestIdProps, testIdProps} from '@github-ui/test-id-props'
import type {Icon} from '@primer/octicons-react'
import {Heading} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {clsx} from 'clsx'

import styles from './automation-block.module.css'

type AutomationBlockProps = {
  icon?: Icon
  iconBg?: string
  iconColor?: string
  headerDescription?: string
  children?: React.ReactNode
} & TestIdProps

export const AutomationBlock = ({
  icon,
  iconBg,
  iconColor,
  headerDescription,
  children,
  ...props
}: AutomationBlockProps) => {
  // Generate a unique ID for aria-labelledby
  const headerId = headerDescription
    ? `automation-block-header-${headerDescription.replace(/\s+/g, '-').toLowerCase()}`
    : undefined

  return (
    <div className={styles.automationBlock} {...testIdProps('automation-block')} {...props} aria-labelledby={headerId}>
      <div className={styles.blockInner}>
        <div className={clsx(styles.blockHeader, children && styles.blockHeaderWithChildren)}>
          {icon && (
            <div
              style={{
                backgroundColor: iconBg,
              }}
              className={styles.iconContainer}
              aria-hidden="true"
            >
              <Octicon icon={icon} color={iconColor} />
            </div>
          )}
          {headerDescription && (
            <Heading as="h3" className={styles.headerDescription} id={headerId}>
              {headerDescription}
            </Heading>
          )}
        </div>
        {children ? <div className={styles.blockContent}>{children}</div> : null}
      </div>
    </div>
  )
}

try{ AutomationBlock.displayName ||= 'AutomationBlock' } catch {}